import { http } from '../rest';

export function fetchTransfers(http, demo) {
  return {
    async execute(clientId, date = '') {
      let data;
      if (demo) {
        const file = await import('./fetchTransfers.data');
        data = file.default;
      } else {
        const response = await http.get(`/clients/${clientId}/transfers/${date}`);
        data = response.data;
      }
      return data;
    },
  };
}

export default fetchTransfers(http, process.env.DEMO);
